import React from 'react';
import LoginForm from '../components/auth/LoginForm';

const Login = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-12rem)]">
      <LoginForm />
    </div>
  );
};

export default Login;